import styled, { keyframes } from "styled-components";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import Empty from "./Empty";
import Table from "./Table";

const filterReports = (reports, userPerms) => {
  if (userPerms?.account_type === 5)
    return reports.filter((report) => report.template_id !== 11);

  if (
    userPerms?.account_type !== 5 &&
    userPerms?.employee_employee_permission?.details?.length > 0
  ) {
    return reports.filter(
      (report) => report.template_id !== 4 && report.template_id !== 11
    );
  }

  return reports;
};

const List = ({ setDeleteId, loading, setDeleteItem }) => {
  const { coreData, pdfReports, get_survey_structure } = useSelector(
    (state) => ({
      coreData: state.audit?.core_data,
      pdfReports: state.debrief_pdf_report,
      get_survey_structure: state.surveystructure.survey_structure,
    }),
    shallowEqual
  );

  return (
    <Container>
      <Center>
        <Title>Report History</Title>
        {(get_survey_structure?.[0]?.categories && pdfReports?.templates &&
          pdfReports?.debrief_pdf_report?.length > 0 && (
            <Table
              data={filterReports(pdfReports?.debrief_pdf_report, coreData?.permissions)}
              categories={get_survey_structure}
              templates={pdfReports?.templates}
              setDeleteId={setDeleteId}
              setDeleteItem={setDeleteItem}
              loading={loading}
            />
          )) || <Empty type="PDF reports" />}
      </Center>
    </Container>
  );
};

export default List;

const fadeIn = keyframes`

    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const Container = styled.div`
  margin-top: 40px;
  font-family: "Raleway";
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Center = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;

  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
`;

const Button = styled.div`
  color: white;
  background-color: #2d70e2;
  font-size: 14px;
  padding: 10px 20px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Raleway";
  border-radius: 8px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-family: "Raleway";
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
